module.exports = __webpack_public_path__ + "static/media/success-check.0200f16a.svg";